import React from 'react';
import { useOfferContext } from '../../../../context';
import { ContentRow } from '../../../../components/ContentRow';
import { Label } from '../../../../components/Label';
import { Header4, Paragraph2, TooltipDesktop } from '@cian/ui-kit';

export function AgentContactStatusContainer() {
  const { agentContactStatus } = useOfferContext();

  if (!agentContactStatus) {
    return null;
  }

  return (
    <TooltipDesktop
      title={
        <>
          <ContentRow>
            <Header4>{agentContactStatus.title}</Header4>
          </ContentRow>
          <Paragraph2>{agentContactStatus.text}</Paragraph2>
        </>
      }
      theme="white"
      placement="bottom"
    >
      <Label text={agentContactStatus.label} theme="success" />
    </TooltipDesktop>
  );
}
